/** @type {(mask: string) => string} */
export const removeMask = (mask) =>
  mask != null &&
  mask.replace(/[.]/, '').replace('-', '').replace(/[.]/, '').replace(/\s/g, '').replace('(', '').replace(')', '')
